<template lang="pug">
  .sliderList(ref="sliderList")
    .arrow.left
    .list.swiper-container
      .swiper-wrapper
        .slide.swiper-slide(v-for="(slide, ind) in slides"
          :data-slide-id="slide.id"
          v-html="slide.name")
    .arrow.right

</template>

<script>
export default {
  name: "SliderList",
  props:['slides', 'activeSlide'],
  data:()=>({
    canScroll: true,
    slider: null,
  }),
  watch:{
    activeSlide(){
      this.slider.slideTo(this.activeSlide, 500);
    }
  },
  methods:{
    initSlider(){
      let that = this;
      this.slider = new Swiper(this.$refs.sliderList.querySelector('.swiper-container'), {
        centeredSlides: true,
        initialSlide: that.activeSlide,
        slidesPerView: 3,
        slideActiveClass: 'active',
        slideToClickedSlide: true,
        navigation: {
          prevEl: this.$refs.sliderList.querySelector('.arrow.left'),
          nextEl: this.$refs.sliderList.querySelector('.arrow.right'),
        },
        on: {
          slideChange: function () {
            let activeSlide = this.slides[this.activeIndex];
            if (activeSlide){
              that.$emit('slideChange', activeSlide.getAttribute('data-slide-id'))
            }
          },
        },
      })
    }
  },
  mounted() {
    this.initSlider();
  },
}
</script>

<style scoped lang="scss">
.sliderList{
  position: relative;
  width: 27rem;
  &.disabled{
    pointer-events: none;
  }
}
.list{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  overflow: hidden;
  .swiper-wrapper{
    align-items: center;
  }
  .slide{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 2rem;
    font-size: to_rem(12px);
    font-weight: bold;
    text-transform: uppercase;
    white-space: nowrap;
    color: #fff;
    cursor: pointer;
    transition: all .15s linear, height 0s;
    opacity: 0.2;
    &:hover {
      opacity: 0.5;
    }
    &.active{
      height: 3rem;
      opacity: 1;
      font-size: to_rem(30px);
    }
  }
}
.arrow{
  position: absolute;
  top: 50%;
  z-index: 10;
  transform: translateY(-50%);
  width: 2rem;
  height: 2.5rem;
  background: url(../assets/img/arrow_right.png) no-repeat center center / contain;
  cursor: pointer;
  &.left{
    right: 93%;
    transform: translateY(-50%) rotate(180deg);
  }
  &.right{
    left: 93%;
  }
}
@include mobile_or_P{
  .sliderList{
    width: 23.5rem;
  }
  .list{
    .slide{
      font-size: 0.65rem;
      &.active{
        font-size: 1.67rem;
      }
    }
  }
  .arrow{
    height: 2.25rem;
    &.left{
    }
    &.right{
    }
  }
}
</style>
